import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { myEventActions } from "../../store/eventManagement";

const ConfirmPayment = ({ onCancel }) => {
  const { eventManagement } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = () => {
    navigate(`/invoice-pdf/${eventManagement?.completedPayment?._id}`);
    dispatch(myEventActions.setCompletedPayment(null));
    onCancel();
  };

  return (
    <div className="flex justify-center items-center dark:bg-primary-darkBg pt-8 dark:border dark:border-gray-500 dark:rounded">
      <div className="bg-white dark:bg-[#1a1d1f] rounded-lg  w-full max-w-lg">
        <div className="p-6 ">
          <div className="text-center">
            <div className="mx-auto mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 text-blue-500 dark:text-white mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8 7V3m8 4V3M3 9h18M4 5h16a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1zm3 9h3m-3 0v3m0-3h3m6-3h3m-3 0v3m0-3h3"
                />
              </svg>
            </div>
            <h3>Booking Confirmed</h3>
            <p>
              We are pleased to inform you that we have received and confirmed
              your reservation request. Please check your email for your
              tickets.
            </p>
          </div>
        </div>

        <div className="px-4 pb-4">
          <button
            className="bg-primary text-white font-bold py-3 px-4 rounded-lg w-full mt-6 text-center"
            onClick={handleNavigate}
          >
            <span className="mr-2">🎫</span> View Ticket
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPayment;
